import { render, staticRenderFns } from "./ProductionRepartitionCamembertCard.vue?vue&type=template&id=2791b09e"
import script from "./ProductionRepartitionCamembertCard.vue?vue&type=script&lang=js"
export * from "./ProductionRepartitionCamembertCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports